import React from "react";
import { connect } from "react-redux";
import { Styles } from "../styles";

import {
  ButtonText,
  CustomText,
  Input,
  InputEmail,
  Select,
} from "../../../components";
import { Fonts, Texts } from "../../../config";
import { Grid } from "@material-ui/core";

import { FormHolder } from "../../../FormConfig";

import { customModal } from "../../modals/utils";

function ModalEdit({ isFetching, roleList, onSubmit, user }) {
  const texts = Texts["pt-BR"].registry;
  const allNames = user?.fullName?.split(" ");
  const firstName = allNames[0];
  allNames.shift();

  return (
    <Styles.ModalContent noPadding>
      <Styles.HeaderModal withPadding>
        <CustomText fontFamily={Fonts.medium} fontSize={1.75}>
          Edite abaixo os dados do usuário selecionado:
        </CustomText>
      </Styles.HeaderModal>
      <Styles.CpfEditModal>
        <CustomText fontFamily={Fonts.bold} fontSize={1.75}>
          CPF:
        </CustomText>
        <CustomText fontFamily={Fonts.medium} fontSize={2}>
          {user?.cpf}
        </CustomText>
      </Styles.CpfEditModal>
      <Styles.InLinePaddingModal>
        <FormHolder onSubmit={onSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Input
                required={texts.userMessage}
                name="firstName"
                inputLabel="NOME USUÁRIO AMCRED"
                defaultValue={firstName}
              />
            </Grid>
            <Grid item xs={6}>
              <Input
                required={texts.userMessage}
                name="lastName"
                inputLabel="SOBRENOME USUÁRIO AMCRED"
                defaultValue={allNames?.join(" ")}
              />
            </Grid>

            <Grid item xs={6}>
              <Select
                required={texts.userMessage}
                name="officeId"
                inputLabel="Cargo"
                options={roleList}
                defaultValue={
                  roleList?.find((item) => item.label === user?.officeName)
                    ?.value
                }
              />
            </Grid>
            <Grid item xs={6}>
              <InputEmail
                name="email"
                required={texts.userMessage}
                inputLabel="E-mail"
                defaultValue={user?.email}
              />
            </Grid>
          </Grid>
          <Styles.FormButtons>
            <ButtonText
              fullWidth={false}
              onClick={() => {
                customModal.close();
              }}
            >
              Voltar
            </ButtonText>
            <Styles.FormButton fullWidth={false} type="submit">
              SALVAR
            </Styles.FormButton>
          </Styles.FormButtons>
        </FormHolder>
      </Styles.InLinePaddingModal>
    </Styles.ModalContent>
  );
}

function mapStateToProps(redux) {
  const { isFetching } = redux.registerAndQuery;
  return { isFetching };
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(ModalEdit));
